<template>
  <div ref="itemsContainer" class="component-products-list-simple px-1">
    <ProductCard v-for="(item, index) in visibleItems" :key="index" :item="item" @click="trackGaEvent(item.id)"/>
  </div>
</template>

<script>
import ProductCard from '@/components/ProductCard.vue'
import enums from '@/utilities/enums.js'

export default {
  name: 'ProductsListSimple',
  components: {
    ProductCard
  },
  mixins: [enums],
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      cardWidth: 157,
      visibleItemsCount: 0
    }
  },
  computed: {
    visibleItems () {
      return this.items.slice(0, this.visibleItemsCount)
    }
  },
  watch: {
    items: function () {
      this.handleResize()
    }
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  methods: {
    handleResize () {
      this.cardWidth = this.globalResources.portalType === this.portalType.Music ? 310 : 157
      let containerWidth = (this.$refs.itemsContainer || { clientWidth: 0 }).clientWidth
      let itemsPerRow = Math.floor(containerWidth / this.cardWidth)
      let rowsCount = Math.round(this.items.length / itemsPerRow)
      this.visibleItemsCount = itemsPerRow * rowsCount
    },
    trackGaEvent(itemId)
    {
      this.$ga.event('Game', 'GamesList', itemId)
    }
  }
}
</script>
